import ApiCore from "./api_core"
import { NewUser, UpdatedUser, UserRoleName } from "./types"

export default new class {
    all(limit=100) {
        return ApiCore.getJson('users', { 'page_size': limit }) 
    }

    get(id: number) { 
        return ApiCore.getJson(`users/${id}`)
    }

    getAllByRole(role: UserRoleName) {
        return ApiCore.getJson('users', { role })
    }

    create(user: NewUser) {
        return ApiCore.postJson('users', user)
    }

    update(id: number, user: UpdatedUser) {
        return ApiCore.putJson(`users/${id}`, user) 
    }

    deactivate(id: number) {
        return ApiCore.postJson(`users/${id}/deactivate`, {})
    }
}
